import { injectable } from "inversify";
import { ApiResponse } from "@/core/models/response.model";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { FeeLadderLevelModel } from "@/core/models/fee-ladder-level.model";

interface _FeeLadderLevelGetParams {
    search?: string;
}

@injectable()
export class FeeLadderLevelRepo extends TableRepo<FeeLadderLevelModel> {
    constructor() {
        super("/api/FeeLadderLevel");
    }

    protected normalizePayload(payload: Partial<FeeLadderLevelModel>) {
        const code = payload.code;
        const normalized = super.normalizePayload(payload);
        // The API keeps the old code for null; an empty string explicitly clears it.
        if (code === "") normalized.code = "";
        return normalized;
    }

    async save(model: FeeLadderLevelModel): Promise<ApiResponse<FeeLadderLevelModel | null>> {
        const path = model.id ? this.updatePath : this.addPath;
        const payload = this.normalizePayload({ ...model });
        const response = await this.apiRepo.postWithErrors<FeeLadderLevelModel>(`${this.basepath}/${path}`, payload);
        if (response.code === "00") this.changes.next(Date.now());
        return response;
    }

    async getData(index: number, params: _FeeLadderLevelGetParams, pageSize = 10): Promise<ApiPage<FeeLadderLevelModel>|null> {
        return await super.getData(index, params, pageSize);
    }
}
